import { Typography} from "@material-ui/core";
import React from "react";
import InfoCard from "../../../../components/InfoCard";
import {useTranslation} from "react-i18next";

const InfoBlock = () => {
  const { t } = useTranslation()

  return (
    <InfoCard hideIcon={true}>
      <Typography
        variant="body2"
        gutterBottom
      >
        {t('widget_info')}
      </Typography>
    </InfoCard>
  )
}

export default InfoBlock
